module.exports = __webpack_public_path__ + "c595202d36082ec63e5e0c75b78ca6fc.svg";